import axios from "../axios";

class DocumentService {

  static Instance() {
    return new DocumentService();
  }

  getAllDocumentTypes() {
    return axios.get("/api/document/type");
  }

  getAllDocumentTypesNames() {
    return axios.get("/api/document/type/name");
  }

  fetchDocuments(containerID) {
    return axios.get("/api/document/list?containerID=" + containerID);
  }

  uploadDocument(formData) {
    return axios.post('/api/document', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  deleteDocument(id) {
    return axios.post("/api/document/delete?documentID=" + id);
  }

  handleDownload(id) {
    return axios.get(`/api/document/download?id=${id}`, {
      responseType: "blob",
    });
  }

  getDocumentSummary(queryString) {
    return axios.get(`/api/document/summary?${queryString}`);
  }

  getFilteredDocuments(filter) {
    return axios.post("/api/document/filter", filter);
  }

  searchDocuments(filters) {
    return axios.post("/api/document/search", filters);
  }

}

export default DocumentService.Instance();